// extracted by mini-css-extract-plugin
export var actions = "_gs-d";
export var benefitCard = "_gs-a";
export var benefitIcon = "_gs-b";
export var benefitLabel = "_gs-c";
export var benefits = "_gs-9";
export var bodyText = "_gs-8";
export var closeButton = "_gs-2";
export var content = "_gs-3";
export var eyebrow = "_gs-4";
export var heading = "_gs-5";
export var image = "_gs-f";
export var imagePanel = "_gs-e";
export var modal = "_gs-0";
export var shell = "_gs-1";
export var title = "_gs-6";
export var titleOffer = "_gs-7";